module.exports = __webpack_public_path__ + "img/classButton-1.b147d5fb.png";